import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Subscription } from 'rxjs';

import { LayoutsService } from 'pn-core-code';

import { AppMenuComponent } from '../app-menu/app-menu.component';
import { AppTopbarComponent } from '../app-topbar/app-topbar.component';

@Component({
  selector: 'layout-default',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AppMenuComponent, AppTopbarComponent],
  templateUrl: './layout-default.component.html',
  styleUrl: './layout-default.component.scss'
})
export class LayoutDefaultComponent implements OnInit, OnDestroy {
  isShowSidebar: boolean = true;

  isShowSidebarSub: Subscription | undefined;


  constructor(
    private layoutsService: LayoutsService
  ) {
    this.isShowSidebarSub = this.layoutsService.isShowSidebar.subscribe(v => {
      console.log('sub', v);
      this.isShowSidebar = v;
    })
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.isShowSidebarSub && this.isShowSidebarSub.unsubscribe();
  }
}
